import React from "react"

export default function Spacer() {
  return <div class="spacer"></div>
}
